import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitoalibaugcab() {



  const cardData = {
    keyword: " Mumbai to Alibaug Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Alibaug cab services, ensuring a smooth, safe, and refreshing coastal journey for families, couples, weekend travelers, and group outings. Whether you are planning a quick beach getaway, one-day picnic, or relaxing staycation, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Alibaug route covers approximately 95 to 110 km depending on the route and takes around 2.5 to 3.5 hours including ferry or road traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Alibaug travel.",

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "Alibaug Beach is the main attraction of the town, known for its black sand, calm shoreline, and scenic sunset views. Visitors can enjoy horse rides, camel rides, and beachside snacks while relaxing near the Arabian Sea. It is a perfect spot for evening walks and photography, especially during low tide when the coastline becomes wide and peaceful."
  },
  {
    "title": "Kolaba Fort",
    "description": "Kolaba Fort is a historic sea fort located just off Alibaug Beach and can be reached during low tide by walking or by boat. Built during the Maratha era, it showcases strong coastal defense architecture and offers panoramic views of the sea, fishing boats, and surrounding coastline."
  },
  {
    "title": "Nagaon Beach",
    "description": "Nagaon Beach is one of the most popular clean beaches near Alibaug, famous for water sports like banana rides, jet skiing, and bumper rides. The beach is lined with coconut and betel nut trees, making it a peaceful yet adventurous destination for families and groups."
  },
  {
    "title": "Kihim Beach",
    "description": "Kihim Beach is known for its clean shoreline, lush greenery, and peaceful environment. It is ideal for nature lovers, bird watchers, and couples looking for a quiet beach experience away from crowded tourist spots."
  },
  {
    "title": "Varsoli Beach",
    "description": "Varsoli Beach is a serene and less crowded beach located close to Alibaug town. It offers soft sand, calm waters, and a relaxing atmosphere perfect for swimming, sunbathing, and peaceful seaside walks."
  },
  {
    "title": "Akshi Beach",
    "description": "Akshi Beach is a quiet and scenic stretch known for its clean surroundings and fishing village vibe. It is ideal for travelers who want to experience authentic coastal life and enjoy peaceful sunsets away from tourist crowds."
  },
  {
    "title": "Revdanda Beach & Fort",
    "description": "Revdanda Beach is a beautiful coastal area combined with the historic Revdanda Fort ruins. The fort reflects Portuguese-era architecture and offers scenic sea views, making it a great spot for history lovers and photographers."
  },
  {
    "title": "Mandwa Beach",
    "description": "Mandwa Beach is a popular gateway point from Mumbai via ferry and is known for its clean shoreline, water sports, and beach resorts. It offers a lively yet relaxed coastal atmosphere with easy accessibility."
  },
  {
    "title": "Korlai Fort",
    "description": "Korlai Fort is a lesser-known historic fort offering stunning views of the Arabian Sea and nearby villages. It is rich in Portuguese history and provides a peaceful trekking experience for adventure lovers."
  },
  {
    "title": "Alibaug Local Markets",
    "description": "Alibaug local markets are vibrant places where visitors can shop for handmade products, coastal souvenirs, fresh seafood, and local Konkani items. It adds a cultural touch to the beach trip experience."
  }
],







services: [
  {
    name: "Mumbai to Alibaug Cab",
    description: "Mumbai to Alibaug cab service offers a quick and relaxing getaway to one of Maharashtra’s most popular beach destinations. The journey includes scenic coastal routes and smooth highways, making it ideal for weekend trips. Perfect for families, couples, and groups, this service ensures comfortable and safe travel. Professional drivers and well-maintained vehicles enhance the experience. Flexible pickup across Mumbai adds convenience. It guarantees a refreshing and hassle-free trip."
  },
  {
    name: "Mumbai to Alibaug Taxi",
    description: "Mumbai to Alibaug taxi provides convenient and private transportation with door-to-door pickup and drop. This service is ideal for travelers looking for a comfortable and flexible ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for short trips and beach vacations. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Alibaug Cab Service",
    description: "Mumbai to Alibaug cab service is designed for fast and reliable travel with a focus on comfort and safety. The route offers beautiful coastal views and smooth driving conditions. This service is perfect for weekend getaways and day trips. Vehicles are regularly serviced for performance. It ensures a dependable travel experience."
  },
  {
    name: "Mumbai to Alibaug Taxi Service",
    description: "Mumbai to Alibaug taxi service offers dependable travel for tourists and families heading to Alibaug beaches. Clean vehicles and trained drivers ensure a comfortable journey. Flexible scheduling allows easy trip planning. Door-to-door service adds convenience. It guarantees a stress-free travel experience."
  },
  {
    name: "Cab from Mumbai to Alibaug",
    description: "Cab from Mumbai to Alibaug provides a personalized and private travel experience with flexible stops along the route. Travelers can enjoy scenic coastal views during the journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Alibaug",
    description: "Taxi from Mumbai to Alibaug offers a quick and convenient way to reach the beach destination. With experienced drivers and comfortable vehicles, this service ensures smooth travel. Door-to-door pickup and drop add convenience. Suitable for day trips and weekend travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Alibaug Cab Booking",
    description: "Mumbai to Alibaug cab booking allows customers to reserve their ride easily with flexible options. Travelers can select vehicle type, pickup location, and travel time. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Alibaug Taxi Booking Online",
    description: "Mumbai to Alibaug taxi booking online provides a quick and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Alibaug Cab Price",
    description: "Mumbai to Alibaug cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Alibaug Taxi Fare",
    description: "Mumbai to Alibaug taxi fare is designed to be affordable and competitive for short-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Alibaug One Way Cab",
    description: "Mumbai to Alibaug one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick beach trips. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Alibaug Round Trip Taxi",
    description: "Mumbai to Alibaug round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Alibaug Innova Cab",
    description: "Mumbai to Alibaug Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group outings. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Alibaug Ertiga Cab",
    description: "Mumbai to Alibaug Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Alibaug Sedan Cab",
    description: "Mumbai to Alibaug sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Alibaug SUV Taxi",
    description: "Mumbai to Alibaug SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Alibaug Cab",
    description: "Cheap Mumbai to Alibaug cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Alibaug Taxi Service",
    description: "Best Mumbai to Alibaug taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Alibaug Cab", "Mumbai to Alibaug Taxi"],
  ["Mumbai to Alibaug Cab Service", "Mumbai to Alibaug Taxi Service"],
  ["Cab from Mumbai to Alibaug", "Taxi from Mumbai to Alibaug"],
  ["Mumbai to Alibaug Cab Booking", "Mumbai to Alibaug Taxi Booking Online"],
  ["Mumbai to Alibaug Cab Price", "Mumbai to Alibaug Taxi Fare"],
  ["Mumbai to Alibaug One Way Cab", "Mumbai to Alibaug Round Trip Taxi"],
  ["Mumbai to Alibaug Innova Cab", "Mumbai to Alibaug Ertiga Cab"],
  ["Mumbai to Alibaug Sedan Cab", "Mumbai to Alibaug SUV Taxi"],
  ["Cheap Mumbai to Alibaug Cab", "Best Mumbai to Alibaug Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Quick & Comfortable Mumbai to Alibaug Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and relaxing Mumbai to Alibaug cab service, perfect for weekend getaways, beach trips, and family outings."
  },
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained on Mumbai to Alibaug coastal routes, ensuring safe driving and a hassle-free journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Alibaug cab service operates 24/7, allowing flexible travel anytime as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Alibaug trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Alibaug cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Alibaug cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Alibaug for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Alibaug?", answer: "The distance is approximately 90 to 110 km and takes around 2.5 to 4 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Alibaug cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak tourist seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Alibaug trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Patil",
    feedback: "The Mumbai to Alibaug cab service with Royal Route Cabs was very smooth and enjoyable. The coastal journey was comfortable and the driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback: "Great experience traveling from Mumbai to Alibaug. The cab was clean, timely, and the ride felt safe and relaxing throughout the trip.",
    rating: 5
  }
];























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-alibaug-cab.jpg", // replace if needed
  "description": "Book Mumbai to Alibaug cab with Royal Route Cabs for a quick and comfortable coastal travel experience. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi service with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-alibaug-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai to Alibaug Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Alibaug cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to alibaug cab, mumbai to alibaug taxi, mumbai to alibaug cab service, mumbai to alibaug taxi service, cab from mumbai to alibaug, taxi from mumbai to alibaug, mumbai to alibaug cab booking, mumbai to alibaug taxi booking online, mumbai to alibaug cab price, mumbai to alibaug taxi fare, mumbai to alibaug one way cab, mumbai to alibaug round trip taxi, mumbai to alibaug innova cab, mumbai to alibaug ertiga cab, mumbai to alibaug sedan cab, mumbai to alibaug suv taxi, cheap mumbai to alibaug cab, best mumbai to alibaug taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoalibaugcab;